import OutlinedInput from '@mui/material/OutlinedInput';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import BtnGradient from 'src/components/common/button/BtnGradient';
import BtnOutlineGradient from 'src/components/common/button/BtnOutlineGradient';
import DialogCompare from './DialogCompare';
import Rows from './Rows';
import Tag from './Tag';
import DialogIntegrate from './DialogIntegrate';

function createData(id: string, kana: string, fullname: string) {
  return { id, kana, fullname };
}

const rows = [
  {
    item: [
      createData('1001471', 'たなか　さくらこ', '田中　櫻子'),
      createData('1001471', 'たなか　さくらこ', '田中　櫻子'),
    ],
  },
  {
    item: [
      createData('1001471', 'たなか　さくらこ', '田中　櫻子'),
      createData('1001471', 'たなか　さくらこ', '田中　櫻子'),
    ],
  },
  {
    item: [
      createData('1001471', 'たなか　さくらこ', '田中　櫻子'),
      createData('1001471', 'たなか　さくらこ', '田中　櫻子'),
    ],
  },
  {
    item: [
      createData('1001471', 'たなか　さくらこ', '田中　櫻子'),
      createData('1001471', 'たなか　さくらこ', '田中　櫻子'),
      createData('1001471', 'たなか　さくらこ', '田中　櫻子'),
    ],
  },
];

type FilterType = {
  keyword: string;
  tag: string;
};

const Integration = () => {
  const [open, setOpen] = useState<boolean>(false);
  const [openIntegrate, setOpenIntegrate] = useState<boolean>(false);
  const [searchs, setSearchs] = useState<FilterType>({
    keyword: '',
    tag: '1',
  });
  const handleSearch = () => {};

  const handleComparative = () => {};

  const handleInputSearch = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.target;
    setSearchs({
      ...searchs,
      [name]: value,
    });
  };

  const handleTagClick = (value: string = '') => {
    console.log(value);
  };

  const onClose = () => {
    setOpen(false);
  };

  const handleDialogComparative = (data: any) => {
    setOpen(true);
  };

  const handleIntegrate = () => {
    setOpen(false);
    setOpenIntegrate(true);
  };

  const handleNotDuplicate = () => {
    console.log('handleNotDuplicate');
  };

  const handleCloseDialogIntegrate = () => {
    setOpenIntegrate(false);
  };
  const handleAgreeIntegrate = () => {
    setOpenIntegrate(false);
  };

  return (
    <Stack width={'100%'}>
      <Stack
        direction={'row'}
        justifyContent={'space-between'}
        spacing={'8px'}
        mb={'30px'}
      >
        <Stack
          direction={'row'}
          justifyContent={'space-between'}
          spacing={'8px'}
        >
          <Stack
            direction={'row'}
            justifyContent={'space-between'}
            spacing={'8px'}
            alignItems={'center'}
            px={'10px'}
            bgcolor={'primary.light'}
            borderRadius={'4px'}
          >
            <Typography fontWeight={700}>
              タグ検索
            </Typography>
            <Tag
              text='患者名'
              color='#23B7E5'
              borderColor='#23B7E5'
              clickable={true}
              minWidth='107px'
              handleClick={() => handleTagClick('患者名')}
            />
            <Tag
              text='患者名（カナ）'
              color='#23B7E5'
              borderColor='#23B7E5'
              clickable={true}
              minWidth='107px'
              handleClick={() => handleTagClick('患者名（カナ）')}
            />
            <Tag
              text='生年月日'
              color='#AAB2BD'
              borderColor='#AAB2BD'
              clickable={true}
              minWidth='107px'
              handleClick={() => handleTagClick('生年月日')}
            />
            <Tag
              text='電話番号'
              color='#23B7E5'
              borderColor='#23B7E5'
              clickable={true}
              minWidth='107px'
              handleClick={() => handleTagClick('電話番号')}
            />
            <Tag
              text='メールアドレス'
              color='#AAB2BD'
              borderColor='#AAB2BD'
              minWidth='107px'
              clickable={true}
              handleClick={() => handleTagClick('メールアドレス')}
            />
          </Stack>
          <OutlinedInput
            placeholder={'患者'}
            sx={{
              fontSize: '14px',
              height: '32px',
              my: '8px',
              '& .MuiOutlinedInput-notchedOutline': { borderColor: '#BDBDBD' },
              '& .MuiInputBase-input': { padding: '5px 14px' },
              '& input::placeholder': {
                fontSize: '14px',
                fontWeight: 500,
                color: '#CCD1D9',
                opacity: 1,
              },
              backgroundColor: 'primary.light',
              width: '200px',
              mr: '8px',
            }}
            inputProps={{
              sx: {
                backgroundColor: 'primary.light',
              },
            }}
            name='keyword'
            value={searchs.keyword}
            onChange={(event) => handleInputSearch(event)}
          />
          <BtnGradient text='検索' handleButtonClick={handleSearch} />
        </Stack>
        <BtnOutlineGradient
          text='比較表示'
          handleButtonClick={handleComparative}
          width='120px'
        />
      </Stack>
      <TableContainer component={Paper}>
        <Table
          sx={{
            minWidth: 650,
            '& .MuiTableCell-root.MuiTableCell-head': {
              borderBottom: '1px solid #F3F3F3',
              fontWeight: 700,
              p: '6px 16px',
              fontSize: '14px',
            },
            '& .MuiTableCell-root.MuiTableCell-body': {
              color: 'primary.dark',
              fontSize: '14px',
              py: '10px',
            },
          }}
          aria-label='simple table'
        >
          <TableHead>
            <TableRow>
              <TableCell>患者ID</TableCell>
              <TableCell>患者名</TableCell>
              <TableCell>重複項目</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.length > 0 &&
              rows.map((item: any, index: number) => (
                <Rows
                  data={item}
                  key={index}
                  handleDialogComparative={handleDialogComparative}
                />
              ))}
            {rows.length === 0 && (
              <TableRow>
                <TableCell
                  colSpan={4}
                  sx={{ textAlign: 'center', verticalAlign: 'center' }}
                >
                  データがありません
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <DialogCompare
        open={open}
        onClose={onClose}
        handleIntegrate={handleIntegrate}
        handleNotDuplicate={handleNotDuplicate}
      />
      <DialogIntegrate
        openIntegrate={openIntegrate}
        handleCloseDialogIntegrate={handleCloseDialogIntegrate}
        handleAgreeIntegrate={handleAgreeIntegrate}
      />
    </Stack>
  );
};

export default Integration;
